// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28L7d","name":"styles_name__3fvcT","phone":"styles_phone__p6m4Y"};